import {
  ICON_COLOR,
  ICON_SIZE,
  PropHeroIcon,
} from "@prophero-ds/react-components";

interface BackButtonProps {
  id?: string;
  onClick: () => void;
  ariaLabel: string;
  className?: string;
}

function BackButton({
  id,
  onClick,
  ariaLabel,
  className = "",
}: BackButtonProps) {
  return (
    <button
      type="button"
      id={id}
      onClick={() => void onClick()}
      className={`flex h-8 w-8 items-center justify-center rounded-full bg-[var(--ds-color-components-button-secondary-bg-default,#d9e7ff)] text-[var(--ds-color-components-button-secondary-fg,#162eb7)] transition-colors hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[var(--ds-color-semantic-color-accent,#3b82f6)] ${className}`.trim()}
      aria-label={ariaLabel}
    >
      <PropHeroIcon
        name="chevron-left"
        color={ICON_COLOR.BRAND}
        size={ICON_SIZE.SM}
      />
    </button>
  );
}

export default BackButton;
